import React from 'react';
import { columns, categories } from './config';
import _ from 'lodash';

export const initialState = {
  list: [],
  counters: [],
  columns: columns,
  columnsRef: React.createRef(),
  categories: categories,
  searchedIndex: 0,
  searchedQuery: '',
  counter: '',
  filters: {},
  sorting: { order: 'desc', column: 'dueDate' },
  showCompletedTasks: false,
  prefilters: {
    workstream: null,
    assignee: null,
    reviewer: null,
    approver: null,
  },
  notificationQueryTaskId: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_TASKS_COUNTERS':
      return {
        ...state,
        counters: action.counters,
      };

    case 'UPDATE_TASKS_COLUMNS':
      return {
        ...state,
        columns: action.columns,
      };

    case 'CLEAR_TASKS_COLUMNS':
      return {
        ...state,
        columns: initialState.columns,
      };

    case 'UPDATE_TASKS_CATEGORIES':
      return {
        ...state,
        categories: action.categories,
      };

    case 'SET_TASKS_LIST':
      return {
        ...state,
        list: action.list,
      };

    case 'UPDATE_TASKS_LIST': {
      let list = state.list;

      for (const item of action.list) {
        const updateIndex = _.findIndex(list, { id: item.id });

        if (updateIndex >= 0) {
          list.splice(updateIndex, 1, { ...list[updateIndex], ...item });
        } else {
          list.push({ ...item, ref: React.createRef() });
        }
      }

      if (action.deletedTaskIds) {
        list = list.filter(
          (task) => action.deletedTaskIds.indexOf(task.id) < 0
        );
      }

      return {
        ...state,
        list: list,
      };
    }

    case 'DELETE_TASKS_ITEM': {
      let list = state.list;

      const updatedList = _.remove(list, (listObj) => {
        return listObj.id !== action.id;
      });

      return {
        ...state,
        list: updatedList,
      };
    }

    case 'CLEAR_TASKS_LIST':
      return {
        ...state,
        list: [],
      };

    case 'UPDATE_TASKS_SEARCHED_INDEX':
      return {
        ...state,
        searchedIndex: action.index,
      };

    case 'UPDATE_TASKS_SEARCHED_QUERY':
      return {
        ...state,
        searchedQuery: action.query,
      };

    case 'SET_TASKS_SORTING':
      return {
        ...state,
        sorting: action.sorting,
      };

    case 'SET_TASKS_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.column]: action.filters,
        },
      };

    case 'SET_TASKS_COUNTER':
      return {
        ...state,
        counter: action.counter,
      };

    case 'SET_TASKS_SHOW_COMPLETED':
      return {
        ...state,
        showCompletedTasks: action.boolean,
      };

    case 'SET_TASKS_NOTIFICATION_QUERY_TASK_ID':
      return {
        ...state,
        notificationQueryTaskId: action.notificationQueryTaskId,
      };

    case 'SET_TASKS_PREFILTERS': {
      return {
        ...state,
        prefilters: {
          ...state.prefilters,
          [action.column]: action.filter,
        },
      };
    }

    case 'ClEAR_TASKS_COLUMN_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.column]: (state.filters[action.column] || []).map((f) => ({
            ...f,
            isActive: true,
          })),
        },
      };

    case 'CLEAR_TASKS_COLUMNS':
      return {
        ...state,
        columns: initialState.columns,
      };

    case 'CLEAR_TASKS_FILTERS':
      return {
        ...state,
        columns: initialState.columns,
        sorting: initialState.sorting,
      };

    case 'CLEAR_TASKS_DATA':
      return initialState;

    default:
      return state;
  }
}
